var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "hero_header",
      style: {
        "--content-bg": "url(" + _vm.parsedImage.url + ")",
        "--quick-links-height":
          _vm.quick_links_height - (_vm.window.width < 1280 ? 140 : 0) + "px",
      },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "text" }, [
            _c("div", { staticClass: "inner" }, [
              _vm.title
                ? _c("h1", {
                    attrs: {
                      "data-highlightword": _vm.getWordsInFirstRow(_vm.title),
                    },
                    domProps: { innerHTML: _vm._s(_vm.title) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.description
                ? _c("div", {
                    staticClass: "body",
                    domProps: { innerHTML: _vm._s(_vm.description) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.parsedCta
                ? _c(
                    "div",
                    { staticClass: "cta_container" },
                    [
                      _c("secondary-button", {
                        attrs: {
                          label: _vm.parsedCta.title,
                          link: _vm.parsedCta,
                          theme: "reverse",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.parsedQuickLinks
              ? _c(
                  "div",
                  { ref: "quickLinks", staticClass: "quicklinks" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._l(_vm.parsedQuickLinks, function (quicklink, index) {
                      return _c("quick-link", {
                        key: index,
                        class: { acc: _vm.window.width < 1280 },
                        attrs: { quicklink: quicklink },
                        on: { click: _vm.handleAccordionToggle },
                      })
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "image",
              style: { "--image-mask": "url(" + _vm.imageMask + ")" },
            },
            [_c("img", { attrs: { src: _vm.parsedImage.url } })]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "quicklinks__title" }, [
      _c("h6", [_vm._v("Quicklinks")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }